import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import DestinationCard from '../../components/BasicUI/Cards/DestinationCard';
import { routeConfiguration } from '../../index';
import { createResourceLocatorString } from '../../util/routes';

const destinationsData = [
  {
    imageUrl: 'https://a.storyblok.com/f/267180/480x280/59fe8fca9a/dog-480p.webp',
    title: 'Wohnmobilstellplatz mit Hund',
    subtitle: 'Was gibt es schöneres als Urlaub mit dem geliebten Familienmitglied?  🐶',
    slug: 'camping',
    rest: 'mit-hund',
  },
  {
    imageUrl: 'https://a.storyblok.com/f/267180/2560x1708/af8e114dd3/adobestock_474043146.webp',
    title: 'Wohnmobilstellplatz am Meer',
    subtitle: 'Sand Strand und das leichte rauschen der Wellen - Was gibt es schöneres!  🌊',
    slug: 'camping',
    rest: 'am-meer',
  },
  {
    imageUrl: 'https://a.storyblok.com/f/267180/1920x1280/5d54717220/halden1080p-_compressed.webp',
    title: 'Wohnmobilstellplatz in den Bergen',
    subtitle: 'Wiesen - Täler und einen fantastischen Ausblick auf die Berge. 🌄',
    slug: 'camping',
    rest: 'in-den-bergen',
  },
  {
    imageUrl:
      'https://a.storyblok.com/f/267180/2400x1592/69ea690bce/62dfa1b7-ae8e-4d7b-b6e9-02a22ab669fb.webp',
    title: 'Wohnmobilstellplatz am Weingut',
    subtitle: 'Wie wäre es mit einem Ausflug in die Weinberge?🍇',
    slug: 'camping',
    rest: 'am-weingut',
  },
  {
    imageUrl: 'https://a.storyblok.com/f/267180/1920x1080/58274e561a/spreewald.webp',
    title: 'Wohnmobilstellplatz Alpaka Camping',
    subtitle:
      'Wie wäre es mit einer Alpaka Wanderung? Perfekt für ein kleines Abenteuer auf deiner Reise! 🦙',
    slug: 'camping',
    rest: 'alpaka',
  },
  {
    imageUrl: 'https://a.storyblok.com/f/267180/1920x1440/e664845be2/stellplatz-pferdekoppel.webp',
    title: 'Wohnmobilstellplatz auf dem Bauernhof',
    subtitle: 'Dein Abenteuerurlaub auf dem Bauernhof mit Blick auf die verschiedensten Tiere.  🐮',
    slug: 'camping',
    rest: 'auf-dem-bauernhof',
  },
  {
    imageUrl:
      'https://a.storyblok.com/f/267180/1920x1440/18faf4088e/badeteich_1080p_compressed.webp',
    title: 'Wohnmobilstellplatz am See',
    subtitle:
      'Das glitzern im Wasser in der Sonne und der Blick in die Natur - so lässt es sich erholen! 💦',
    slug: 'camping',
    rest: 'am-see',
  },
  {
    imageUrl: 'https://a.storyblok.com/f/267180/2560x1707/0b27da71ee/maximiliansweg.webp',
    title: 'Wohnmobilstellplatz Wald & Wiesen',
    subtitle:
      'Pure Idylle inmitten von Wäldern und Wiesen. Hier kannst du so richtig entspannen   🌳',
    slug: 'camping',
    rest: 'im-wald',
  },
];

/**
 * SectionDestinationsComponent displays a section of destination cards.
 *
 * @component
 * @returns {React.ReactElement} A React component that renders a grid of destination cards.
 */
const SectionDestinationsComponent = () => {
  const intl = useIntl();

  return (
    <Container
      maxWidth="xl"
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}
    >
      <Typography component="h2" sx={{ mb: 2 }} variant="h3">
        <FormattedMessage id="SectionDestinations.header" />
      </Typography>
      <Grid container justifyContent="center" spacing={2}>
        {/* Map through the static destinationsData */}
        {destinationsData.map((entry, index) => {
          const link = createResourceLocatorString(
            'StoryblokPage',
            routeConfiguration(),
            { slug: entry.slug, rest: entry.rest },
            {},
            intl.locale,
          );

          return (
            <Grid key={index} size={{ lg: 3, md: 4, sm: 6, xs: 12 }}>
              <DestinationCard
                image={{
                  id: 'generated-id',
                  filename: entry.imageUrl,
                  alt: entry.title,
                  title: entry.title,
                }}
                link={link}
                subtitle={entry.subtitle}
                title={entry.title}
              />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

const SectionDestinations = memo(SectionDestinationsComponent);
SectionDestinations.displayName = 'SectionDestinations';
export default SectionDestinations;
